var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.nav.length > 0)?_c('ul',{staticClass:"hidden-xs hidden-sm",attrs:{"id":"left-nav"}},_vm._l((_vm.nav),function(child,i){return _c('NavItem',{key:i,attrs:{"nav":child,"ariaID":i,"currentPageXID":_vm.currentPageXID,"serverPath":_vm.serverPath}})}),1):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }